import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleNavigateEvent = (event) => {
      const { path } = event.detail;
      if (path) {
        navigate(path);
      }
    };

    // Listen for custom navigation events from notifications
    window.addEventListener('navigate-to', handleNavigateEvent);

    return () => {
      window.removeEventListener('navigate-to', handleNavigateEvent);
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default NavigationHandler;
